export const SEGMENT_TOUR_TARGET = {
  MODE_SWITCH: "mode-switch",
  TABS: "tabs",
  COMBINE: "combine",
  MATCH: "match",
  CONDITIONS: "conditions",
  CONDITION_EDITOR: "condition-editor",
  FIELD_LIST: "field-list",
  OPERATOR_LIST: "operator-list",
  VALUE_LIST: "value-list",
  EXCLUDE: "exclude",
  COUNT: "count",
  EXCEPTIONS: "exceptions",
  VACANCIES: "vacancies",
  VACANCY_SEARCH: "vacancy-search",
  VACANCY_FILTERS: "vacancy-filters",
  VACANCY_LISTS: "vacancy-lists",
  VACANCY_FLIP: "vacancy-flip",
  HISTORY: "history",
  SAVE: "save",
  ARCHIVE: "archive",
  OVERVIEW_SEGMENT: "overview-segment",
  OVERVIEW_STATUS: "overview-status",
  OVERVIEW_ADD: "overview-add",
  OVERVIEW_WHERE_USED: "overview-where-used",
  OVERVIEW_VACANCIES: "overview-vacancies",
  OVERVIEW_ACTIVITY: "overview-activity",
  OVERVIEW_OPEN: "overview-open",
  OVERVIEW_ARCHIVE: "overview-archive",
} as const;

export const TOUR_DEMO_CONTROL = {
  FIELD: "field",
  OPERATOR: "operator",
  VALUE: "value",
} as const;

export type TourDemoControl = (typeof TOUR_DEMO_CONTROL)[keyof typeof TOUR_DEMO_CONTROL];
